import { render, staticRenderFns } from "./IdentityEntry.vue?vue&type=template&id=95d0aad0&scoped=true"
import script from "./IdentityEntry.vue?vue&type=script&lang=js"
export * from "./IdentityEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0aad0",
  null
  
)

export default component.exports